import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { FileUpload } from 'rxjs-uploader';
import { Icons } from '../../../constants/icons.constants';
import { Utilities } from '../../../utilities/utilities.helper';

@Component({
    selector: 'lsq-file-picker',
    template: `
        <input
            [id]="name + '-input'"
            [attr.aria-labelledby]="name + '-label'"
            #filePicker
            type="file"
            [(ngModel)]="fileSourceValue"
            (change)="fileSourceValueChanged.emit($event)"
        />
        <div
            [id]="name"
            class="lsq-file-picker"
            [ngClass]="{ selected: fileSourceValue }"
            (click)="openFilePicker()"
        >
            <div class="file-picker-label">
                <lsq-icon [type]="fileSourceValue ? icons.Paperclip : icons.Add"></lsq-icon>
                <span [id]="name + '-placeholder-text'" class="file-picker-text">
                    {{
                        (fileSourceValue && fileSourceValue.replace(filePathRegex, '$1')) ||
                            placeholderText
                    }}
                </span>
            </div>
            <lsq-button
                [id]="name + '-remove-button'"
                appearance="transparent"
                class="format-text"
                i18n
                *ngIf="fileSourceValue && !hideRemoveButton"
                (buttonClick)="removeFile()"
            >
                REMOVE
            </lsq-button>
        </div>
        <div class="error" *ngIf="uploadErrorMessage">
            <lsq-icon [type]="icons.AlertError" [height]="20" [width]="20" class="icon"> </lsq-icon>
            <span [innerHTML]="uploadErrorMessage"></span>
        </div>
        <div
            class="upload"
            [ngClass]="{
                'upload-progress-bar': fileUpload?.uploading
            }"
            [style.marginTop]="'3rem'"
        >
            <div *ngIf="fileUpload?.uploading">
                <lsq-progress-bar [value]="fileUpload?.progressPercentage"> </lsq-progress-bar>
                <div class="upload-progress-bar-text">
                    <b class="upload-progress-bar-bold">Please Wait -</b>
                    <span>Do Not Exit this page while your upload is in progress.</span>
                </div>
            </div>
        </div>
    `,
    styleUrls: ['./lsq-file-picker.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LsqFilePickerComponent implements AfterViewInit {
    @ViewChild('filePicker') public filePickerElement: ElementRef;
    @Input() public placeholderText: string;
    @Input() public hideRemoveButton = false;
    @Input() public name = 'file-picker';
    @Input() public uploadErrorMessage: string;
    @Input() public fileUpload: FileUpload;
    @Output() public fileSourceValueChanged = new EventEmitter<string>();
    @Output() public fileSourceElementChanged = new EventEmitter<ElementRef>();

    public filePathRegex = /^.*?([^\\\/]*)$/;
    public icons = Icons;
    public fileSourceValue: string;

    public ngAfterViewInit(): void {
        Utilities.executeAfterRender(() => {
            this.fileSourceElementChanged.emit(this.filePickerElement);
        });
    }

    public openFilePicker(): void {
        if (!this.fileSourceValue) {
            this.filePickerElement.nativeElement.click();
        }
    }

    public removeFile(): void {
        this.fileSourceValue = null;
        this.fileSourceValueChanged.emit(null);
    }
}
